import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import '../assets/style/index.css';

const ActiveMail = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const email = params.get('email');
  const t = params.get('t');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  // Récupérer l’email passé via navigation
  //const emailUtilisateur = location.state?.email;
	
  const sendEmail = () => {
    if (!email) {
		setMessage('Impossible d\'envoyer le mail : adresse non disponible.');
		setMessageType('danger');
      //alert('Impossible d\'envoyer le mail : adresse non disponible.');
      return;
    }
	 if (!t) {
		setMessage('Le lien est erronné.');
		setMessageType('danger');
      //alert('Impossible d\'envoyer le mail : adresse non disponible.');
      return;
    }
    
    axios.get(`https://ekapi.bblconcept.com/ActiveMail.php?t=${encodeURIComponent(t)}&email=${encodeURIComponent(email)}`)
		.then(res => {
		  setMessage(res.data.message);
		  setMessageType('success');
		})
        .catch(err => {
			  const errorMsg = err.response && err.response.data && err.response.data.message
				? err.response.data.message
				: 'Erreur inconnue lors de l\'activation.';
			  setMessage(errorMsg);
			  setMessageType('danger');
			});
    }

  useEffect(() => {
	  if (email) {
		// Appel de l'API à l'ouverture de la page
		sendEmail();
		
	  }
	  else {
      setMessage("Adresse email manquante dans l'URL");
      setMessageType('danger');
    }

    // Cacher le message après 5 secondes
    const timer = setTimeout(() => {
      setShowMessage(false);
    }, 5000);

    return () => clearTimeout(timer); // nettoyage
  }, [email]); // Les crochets vides signifient que cet effet se produit au montage seulement

  const [showMessage, setShowMessage] = useState(true);

  return (
    <div className="container text-center my-5">
		<div className="text-center">
		  
			<p className="mb-4 text-secondary" style={{ fontSize: '14px' }}>
			  <img src="logo2.jpg" className="logoConnexion" alt="Logo"/>
			</p>
		</div>
	
	  {messageType === 'danger' ? (
		  <div className="alert alert-danger position-relative p-5 animate__animated animate__fadeIn" style={{ fontSize: '1.5em', borderRadius: '15px' }}>
		  <i className="bi bi-x-lg text-dangexr" style={{ fontSize: '80px', animation: 'pulse 2s infinite' }}></i>
			<p className="text-center alert">{message}</p>
			<div className="d-flex justify-content-between mt-3">
			  <p className="btn-info">Revenir à la page de connexion dans l'application</p>
			</div>
		  </div>
		) : (
		  <div className="alert alert-success position-relative p-5 animate__animated animate__fadeIn" style={{ fontSize: '1.5em', borderRadius: '15px' }}>
			<i className="bi bi-check-circle-fill text-success" style={{ fontSize: '80px', animation: 'pulse 2s infinite' }}></i>
			<h2 className="mt-3">Votre compte est désormais activé !</h2>
			<p className="lead">Profitez pleinement des fonctionnalités et service de la plateforme SADA.</p>
			<div className="d-flex justify-content-between mt-3">
			  <p className="btn-info">Retournez sur l'application pour vous connecter</p>
			</div>
		  </div>
		)}
    </div>
  );
};

export default ActiveMail;
